import apiClient from "../apiClient";

export const getAllPromotionsAPI = async () => {
  try {
    const responsePromotions = await apiClient.get("promotions/get-all");
    return responsePromotions?.data?.data || [];
  } catch (error) {
    throw error;
  }
};
export const createPromotionAPI = async (promotion) => {
  try {
    const responsePromotion = await apiClient.post(
      "promotions/create-promotion",
      promotion
    );
    return responsePromotion?.data;
  } catch (error) {
    throw error;
  }
};

export const updatePromotionAPI = async (promotion, promotionId) => {
  try {
    // console.log("Datos a enviar para actualizar la promoción:", promotion);
    // console.log("ID de la promoción:", promotionId);

    const responsePromotion = await apiClient.put(
      `promotions/update-promotion/${promotionId}`,
      promotion
    );
    return responsePromotion?.data;
  } catch (error) {
    throw error;
  }
};

export const deletePromotionAPI = async (promotionId) => {
  try {
    const responsePromotion = await apiClient.delete(
      `promotions/delete-promotion/${promotionId}`
    );
    return responsePromotion?.data;
  } catch (error) {
    throw error;
  }
};
